import type { JSX } from 'react';
import { useEffect } from 'react';
import type { HearingLossExaminationDataV2 } from '@common/validation/customControls/hearingLoss/hearingLossExamination/hearingLossExaminationV2';
import type { InputComponentsMap } from '@frontend/formEngine/editForm/editForm.types';
import { hearingLossExaminationSectionsV2 } from '@common/validation/customControls/hearingLoss/hearingLossExamination/hearingLossExaminationV2';
import { EditForm } from '@frontend/formEngine/editForm/EditForm';
import { useProcessActivityEditContext } from '@frontend/utils';
import { usePatientEpisodeCategoryContext } from '@frontend/utils/hooks/usePatientEpisodeCategoryContext';
import { GeneralPractitionerSelector } from '../../../GeneralPractitionerSelector';
import { PatientConsentCheckbox } from '../../hearingLossComponents/PatientConsentCheckbox';

export function HearingLossExaminationEditV2(): JSX.Element {
    const { data, onChange, processActivityId } = useProcessActivityEditContext<HearingLossExaminationDataV2>();
    const { patient } = usePatientEpisodeCategoryContext();

    // TODO: CS-23832 Make this effect generic (and reuse in v1)
    useEffect(() => {
        if (!processActivityId && (patient.emailAddress || patient.mobileNumber)) {
            onChange({
                patient: {
                    emailAddress: data.patient.emailAddress ?? patient.emailAddress ?? null,
                    mobileNumber: data.patient.mobileNumber ?? patient.mobileNumber ?? null,
                },
            });
        }
    }, [processActivityId, patient.emailAddress, patient.mobileNumber]);

    return (
        <EditForm
            inputComponents={getInputComponents()}
            sections={hearingLossExaminationSectionsV2}
        />
    );
}

function getInputComponents(): InputComponentsMap<keyof HearingLossExaminationDataV2> {
    const map: InputComponentsMap<keyof HearingLossExaminationDataV2> = new Map();
    map.set('toestemming_van_patient', <PatientConsentCheckbox />);
    map.set('generalPractitioner', <GeneralPractitionerSelector />);

    return map;
}
